var themeLazyLoad = {
    init: function () {
        var $elems = $('[data-lazy]').not('img');

        if ($elems.length > 0 && typeof $elems.waypoint === 'function') {
            $elems.waypoint(function () {
                var $el = $(this.element);
                var urlToLoad = $el.data('lazy');
                // If setted loads mobile image under 798px
                if ($(window).width() <= 480 && $el.data('lazyMobile') != '' && $el.data('lazyMobile') != undefined) {
                    urlToLoad = $el.data('lazyMobile');
                }
                var elImage = new Image();
                elImage.src = urlToLoad;
                elImage.onload = function () {
                    $el.css({
                        'backgroundImage': 'url(' + elImage.src + ')'
                    });
                    $el.addClass('lzloaded');
                    setTimeout(function () {
                        $el.addClass('lzloaded');
                    }, 150);
                };
            }, {
                offset: '90%'
            });
        }


        var $elemsV = $('[data-lazy-iframe]');

        if ($elemsV.length > 0 && typeof $elemsV.waypoint === 'function') {
            $elemsV.waypoint(function () {
                var $el = $(this.element);
                var urlToLoad = $el.data('lazy-iframe');
                $el.prop('src', urlToLoad);
            }, {
                offset: '90%'
            });
        }

        var $elemsImg = $('[data-lazy-img]');
        if ($elemsImg.length > 0 && typeof $elemsImg.waypoint === 'function') {
            $elemsImg.waypoint(function () {
                var $el = $(this.element);
                var urlToLoad = $el.data('lazy-img');
                var elImage = new Image();
                elImage.src = urlToLoad;
                elImage.onload = function () {
                    $el.attr("src", elImage.src);
                    $el.addClass('lzloaded');
                };
            }, {
                offset: '100%'
            });
        }
    }
};


function goToPos(ref, offset) {

    var defaultOffset = ($(window).width() <= 798) ? 45 : 70;

    if (typeof offset === 'undefined') offset = defaultOffset;
    $ref = (typeof ref === 'string') ? $(ref) : ref;
    if ($(ref).length == 0)
        //return false;
        $ref = $("body");

    var myPos = $ref.offset().top - offset;

    function getDuration(target) {
        var minDuration = 300;
        var currentTop = $(window).scrollTop(),
            rate = 0.3,
            distance = Math.abs(currentTop - target);
        ret = distance * rate;
        return (ret > minDuration) ? ret : minDuration;
    }


    $('html,body').animate({
        scrollTop: myPos
    }, {
        duration: getDuration(myPos)
    });
}

var addBodyBrowserClass = {

    init: function () {

        this.addClass();

    },

    addClass: function () {

        // Opera 8.0+
        var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

        // Firefox 1.0+
        var isFirefox = typeof InstallTrigger !== 'undefined';

        // Safari 3.0+ "[object HTMLElementConstructor]"
        var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
            return p.toString() === "[object SafariRemoteNotification]";
        })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

        // Internet Explorer 6-11
        var isIE = /*@cc_on!@*/ false || !!document.documentMode;

        // Edge 20+
        var isEdge = !isIE && !!window.StyleMedia;

        // Chrome 1 - 71
        var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

        // Blink engine detection
        var isBlink = (isChrome || isOpera) && !!window.CSS;

        if (isEdge) {
            $('body').addClass('browser-edge');
        }


    }

}


var linkAll = {

    init: function () {
        $('.linkFrom').each(function () {
            var elemToLink = $(this).parents('.linkTo');
            var pageLink = $(this).attr('href');
            var linkTarget = (typeof $(this).attr('target') !== 'undefined') ? $(this).attr('target') : '';
            var nobarba = $(this).hasClass('no-barba');
            if (pageLink !== undefined && pageLink !== 'javascript:;') {
                elemToLink.addClass('pointer').click({
                    myLink: pageLink,
                    myTarget: linkTarget,
                    nobarba: nobarba
                }, function (e) {
                    e.preventDefault();
                    if (e.data.myTarget === '_blank') {
                        window.open(e.data.myLink);
                    } else {
                        if (typeof barbaJs !== 'undefined' && !e.data.nobarba) {
                            Barba.Pjax.goTo(e.data.myLink);
                        } else {
                            location.href = e.data.myLink;
                        }
                    }
                });
            }
        });
    },

    /**
     * ELEMENTI PARZIALMENTE LINKABILI (aree diversificate all'interno dello stesso contenitore)
     */
    initParts: function () {
        var elems = $('.linkFromPart');
        var elemsLg = elems.length;
        if (elemsLg > 0) {
            var i = 0;
            for (i; i <= elemsLg - 1; i++) {
                var el = $(elems[i]);
                var pageLink = el.attr('href');
                if (pageLink !== undefined) {
                    var blockWrap = el.parents('.linkWrap');
                    var elemsToLink = $('.linkToPart', blockWrap);
                    var nobarba = $(this).hasClass('no-barba');
                    elemsToLink.addClass('pointer').click({
                        pageLink: pageLink,
                        nobarba: nobarba
                    }, function (e) {
                        if (typeof barbaJs !== 'undefined' && !e.data.nobarba) {
                            Barba.Pjax.goTo(e.data.pageLink);
                        } else {
                            location.href = e.data.pageLink;
                        }
                    });
                }
            }
        }
    }
}

function iOSBodyClass() {
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    $('body').toggleClass('is-iOS', iOS);

}


var pageStores = {
    selector: '.splash-page',
    mainClass: 'splash-page',
    iso2: (typeof storeIso != 'undefined') ? storeIso : 'en',
    internationalUrl: '//www.comfortzoneskin.com/cdn/shop/t/3/assets/round_flag_international.svg?v=80108939912663198591620376174',
    continents: [],
    countries: [],
    countriesByContinent: [],
    stores: [],
    HTML: [],
    geoData: null,
    customerCountry: null,
    customerContinent: null,
    customerUrl: null,
    init: function () {
        this.setCountryCode();
        
        this.setCookieRedirectBtn();
        this.checkCookieRedirect();
        
        if (typeof comfortzone_stores == 'object' && typeof comfortzone_stores.countries == 'object' && comfortzone_stores.countries.length > 0) {
            this.show();
        }
    },
    show: function () {
        var $wrap = $(this.selector + '__body');
        if ($wrap.length == 1) {
            this.populate();
        }
    },
    formatOptions: function(s){
        var self = this;
        if (!s.id) {
            return s.text;
        }

        return $(`
        <span class="${pageStores.mainClass}__option">
            <img class="${pageStores.mainClass}__flag" src="${s.flag}" width="20" height="20" alt="Davines shop ${s.text}" />
            <span class="${pageStores.mainClass}__option-text">${s.text}</span>
            <span class="${pageStores.mainClass}__shop_wrap">${s.shopIcon}</span>
        </span>`);
    },
    formatSelection: function(s){
        var self = this;
        if (!s.id) {
            return s.text;
        }

        return $(`
        <span class="${pageStores.mainClass}__option">
            <img class="${pageStores.mainClass}__flag" src="${s.flag}" width="20" height="20" alt="Davines shop ${s.text}" />
            <span class="${pageStores.mainClass}__option-text">${s.text}</span>
        </span>`);
    },
    populate: function () {

        $(`${this.selector}__btn-wrap`).hide();

        let cont = [],
            cont_counter = 0,
            countries_counter = 0,
            self = this;

        for (let i in comfortzone_stores.countries) {
            let s = comfortzone_stores.countries[i],
                flag = this.internationalUrl.replace('_international', '_' + s.iso2),
                name = (typeof s.locale != 'undefined' && typeof s.locale[this.iso2] != 'undefined') ? s.locale[this.iso2] : s.name,
                shopIcon = (s.shop) ? '<img src="//www.comfortzoneskin.com/cdn/shop/t/3/assets/ecomm-icon.svg?v=8834785459707722591620376145" class="' + this.mainClass + '__shop-icon">' : '';

                if(s.iso2 == self.customerCountry){
                    self.customerContinent = s.continent;
                    self.customerUrl = s.url;
                }

                // Continents data
                if(cont.indexOf(s.continent) == -1){
                    cont.push(s.continent);
                    this.continents.push({
                        id: s.continent,
                        text: s.continent
                    });
                    // Continents countries data
                    if(typeof this.countries[s.continent] == 'undefined'){
                        this.countries[s.continent] = [];
                    }
                }

                // Countries data
                this.countries[s.continent].push({
                    id: s.iso2,
                    text: s.name,
                    flag: flag,
                    shopIcon: shopIcon,
                    url: s.url
                });
        }

        // Create data structure for all countries in the same select (meh)
        for (let i in this.continents) {
            this.countriesByContinent.push({
                'text' : this.continents[i].text,
                'children': this.countries[this.continents[i].id]
            });
        }

        this.UIBehaviors();
    },
    UIBehaviors: function(){
        var self = this,
            hasContinent = $('#splash-continent').length;

        this.UIActivate(hasContinent);
        this.UIPreselect(hasContinent);
    },
    UIActivate: function (hasContinent) {
        var self = this;

        if(hasContinent){

            // Countries shown on continent selection

            $('#splash-continent').select2({
                placeholder: 'Area or continent',
                allowClear: true,
                data: this.continents,
                minimumResultsForSearch: Infinity
            });

            $('#splash-country').select2({
                placeholder: 'Country/Region',
                allowClear: true,
                data: this.countries
            });

            $('#splash-continent').change(function(){
                let val = $(this).val()
                $('#splash-country').select2('destroy').html('<option></option>');
                $('#splash-country').select2({
                    placeholder: 'Country/Region',
                    allowClear: true,
                    data: self.countries[val],
                    templateResult: pageStores.formatOptions,
                    templateSelection: pageStores.formatSelection
                });
            });

            $('#splash-continent').on('select2:select', function (e) {
                self.hideBtn();
            });

        } else {

            // All countries shown in one select

            $('#splash-country').select2({
                placeholder: 'Country/Region',
                allowClear: true,
                data: this.countriesByContinent,
                templateResult: pageStores.formatOptions,
                templateSelection: pageStores.formatSelection
            });

        }

        $('#splash-country').on('select2:select', function (e) {
            var url = e.params.data.url;
            self.showBtn(url);
        });
    },
    UIPreselect: function(hasContinent){
        if(this.customerCountry != null && this.customerUrl != null){
            if(hasContinent && this.customerContinent != null) $('#splash-continent').val(this.customerContinent).trigger('change');
            $('#splash-country').val(this.customerCountry).trigger('change');
            this.showBtn(this.customerUrl);
        }
    },
    showBtn: function(url){
        $(`${pageStores.selector}__btn-wrap`).slideDown(150, function(){
            $(this).find('a').prop('href',url)
        });
    },
    hideBtn: function(){
        $(`${pageStores.selector}__btn-wrap`).slideUp(150);
    },
    setCountryCode: function(){
        var self = this,
            hasContinent = $('#splash-continent').length;
        if (typeof Geolizr != 'undefined') {

            Geolizr.getGeoData(function (geoData) {

                self.geoData = geoData;
                self.customerCountry = geoData.countryCode.toLowerCase();
                self.UIPreselect(hasContinent);
            });

        }
    },
    checkCookieRedirect: function() {
        // If redirect cookie is set, and we are not already in the choose websiite let's redirect to the right one.
            var redirectUrl = Cookies.get('davines_store_redirect');
            if(redirectUrl != null && redirectUrl.length > 1){
                window.location.href = redirectUrl;
                return false;
            }
    },
    setCookieRedirectBtn: function() {
        $('#go-to-shop').click(function(){
            var url = $(this).prop('href');
            Cookies.set('davines_store_redirect', url , { expires: 180 });
            return true;
        });
    }
}

var redirectPopup = {

    selector: '#modalRedirect',
    stores: {},
    geoData: null,
    countryCode: '',

    init: function () {

        var poupActive = false,
            self = this,
            alreadyShown = Cookies.get('davines_store_modal');


        if (typeof Geolizr != 'undefined') {

            Geolizr.getGeoData(function (geoData) {

                self.geoData = geoData;
                self.countryCode = geoData.countryCode.toLowerCase();

                // If store is enabled and we can retrieve information about user country, then we search into Stores for a matching one
                if (poupActive && alreadyShown !== 'true') {
                    var matchStore = self.matchUserCountryWithStore();
                }
            });

        }

    },

    matchUserCountryWithStore: function () {

        var self = this,
            storesDataAvailable = (typeof comfortzone_stores == 'object' && typeof comfortzone_stores.countries == 'object' && comfortzone_stores.countries.length > 0),
            ret = false;

        // Search thoughout all Stores for one matching the
        if (self.countryCode != '' && storesDataAvailable) {
            for (i in comfortzone_stores.countries) {
                var s = comfortzone_stores.countries[i];

                if (self.countryCode == s.iso2 && s.show_select) {
                    self.showModal(s);
                    break;
                }
            }
        }

        return ret;
    },

    showModal: function (store) {

        if (typeof store === 'undefined') return false;

        var title = "Seems like you are browsing from ###COUNTRY###",
            $modal = $(this.selector),
            internationalUrl = '//www.comfortzoneskin.com/cdn/shop/t/3/assets/round_flag_international.svg?v=80108939912663198591620376174',
            flag = internationalUrl.replace('_international', '_' + store.iso2);


        // Set cookie in order to bother only once per month :)
        Cookies.set('davines_store_modal', true, {
            expires: 180,
            domain: 'davines.com'
        });


        // Fill content
        $modal
            .find('.modal-text')
            .html('')
            .append('<div class="modal-country__flag-header"><img src="' + flag + '" alt="Davines shop ' + name + '" class="modal-country__flag" width="30" height="30"></div>')
            .append('<h4 class="modal-country__title">' + title.replace('###COUNTRY###', store.name) + '</h4>');


        // Cta
        $modal.find('.go-to-website').click(function () {
            if (typeof url != 'undefined' && url != '') {
                window.location.href = store.url;
            }
        });

        // Finally show modal
        setTimeout(function () {
            $modal.modal('show');
        }, 5000);

    }
}


//document ready
$(function () {
    pageStores.init();
    // redirectPopup.init();
    addBodyBrowserClass.init();
    linkAll.init();
    linkAll.initParts();
    iOSBodyClass();
    themeLazyLoad.init();

});